<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          nombreLeyenda="Nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Tipos de Artículos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="articulosTipos" 
              :fields="articulosTiposFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Tipo de Artículo</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import Filtro from '../shared/listFiltroNombre.vue';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'articulosTipos/getField',
  mutationType: 'articulosTipos/updateField',
});

export default {
  name: 'ArticulosTiposList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      articulosTiposFields: [
        {
          key: 'nombre',
          sortable: true
        },
        /*
        {
          key: 'descripcion',
          sortable: true
        },
        */
        {
          key: 'rubroTrabajo',
          label: 'Rubro',
          sortable: true
        },
        { 
          key: 'inactivo',
          class: 'text-center', 
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'articulosTipos',
      'nombre',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('articulosTipos/getArticulosTipos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ArticuloTipoData', 
                          params: { id: item.id }})
    },
    editar (item) {
      this.$router.push({ name: 'ArticuloTipoABM', 
                          params: { id: item.id }})
    },
    agregar () {
      this.$router.push({ name: 'ArticuloTipoABM', 
                          params: { id: 0 }})
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
</style>
